import { useState } from 'react';

import MessageModal from 'app/components/MessageModal';

const ConfirmModal = props => {
  const {
    // this is passed by ConfirmModalProvider so it can control the state
    showConfirmModalRef
  } = props;

  const initialState = {
    isOpen: false,
    message: null,
    resolve: null,
    reject: null
  }

  const [state, setState] = useState(initialState);

  const showConfirmModal = message => {
    return new Promise((resolve, reject) => {
      setState({
        isOpen: true,
        message,
        resolve,
        reject
      });
    });
  }

  showConfirmModalRef.current = showConfirmModal;

  const onConfirm = () => {
    state.resolve();
    setState(initialState);
  }

  const onClose = () => {
    state.reject();
    setState(initialState);
  }

  return (
    <MessageModal
      isOpen={state.isOpen}
      onPrimaryButtonClick={onConfirm}
      onSecondaryButtonClick={onClose}
      onClose={onClose}
      title="Confirm"
      message={state.message || 'Are you sure?'}
    />
  )
}

export default ConfirmModal;
